import FintupComponent from './FintupComponent'
import SessionController from '../core/SessionMobx'
import ReactGA from 'react-ga'
import transverser from '../utils/transverser'
import config from '../config/config'
import utils from '../utils/utils'

class FintupPrivateView extends FintupComponent {
  constructor (props) {
    super(props)
    SessionController.checkSession()
  }

  getPath () {
    return transverser.get('route.path', '')(this.props)
  }

  componentWillMount () {
    utils.scrollToTop()
    if (config.googleAnalyticsEnabled) {
      let actualPath = this.getPath()
      if (actualPath) {
        ReactGA.pageview(actualPath)
      }
    }
  }
}
export default FintupPrivateView
